"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CaretRightFill = {
    name: 'caret-right',
    theme: 'fill',
    nameWithTheme: 'caret-right-fill',
    tag: 'svg',
    attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M392.7 76.3l489.1 403.1c18.9 16.9 18.9 46.5 0 63.4L392.7 947.7c-27.4 24.4-70.8 5-70.8-31.7V107.9c.1-36.6 43.4-56.1 70.8-31.6z'
            },
            children: []
        }
    ]
};
exports.default = CaretRightFill;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/fill/CaretRightFill.js
// module id = 503
// module chunks = 0 1